<div class="d-flex flex-column align-items-center">
    <div class="spinner spinner-border text-secondary" role="status"></div>
    <div class="text-spinner">{{ "loading-information" | lang }}</div>
</div>
